/* WaveBeats — Product Form JS (ENFANT / HÉROS)
 * File: assets/wavebeats-form-kids.js
 * Clone du form film — companions réutilisés (chanson, express, durée). Pas de YouTube.
 */

var WB_VARIANTS = {
  chanson:   52663551885645,  // Chanson Disney personnalisée (+29€)
  express:   50345935634765,  // Livraison Express (+39€)
  duree_60s: 52634347012429,  // Durée 60 secondes (+19€)
  duree_90s: 52634347045197   // Durée 90 secondes (+29€)
};

var UPLOAD_ENDPOINT = 'https://wavebeats-production.up.railway.app/upload-photo';

/* ─── Accordion ─────────────────────────────────────────────────────────── */

function wbToggle(header) {
  var body = header.nextElementSibling;
  var isClosed = header.classList.contains('wb-closed');
  if (isClosed) {
    header.classList.remove('wb-closed');
    body.classList.remove('wb-hidden');
  } else {
    header.classList.add('wb-closed');
    body.classList.add('wb-hidden');
  }
}

/* ─── Remove photo ───────────────────────────────────────────────────────── */

function wbRemovePhoto(btn, zoneId, hiddenId, event) {
  if (event) { event.stopPropagation(); event.preventDefault(); }
  var zone = document.getElementById(zoneId);
  var hidden = document.getElementById(hiddenId);
  if (zone) {
    zone.classList.remove('wb-has-file', 'wb-uploading');
    var preview = zone.querySelector('.wb-preview');
    if (preview) {
      preview.style.display = 'none';
      var img = preview.querySelector('img');
      if (img) img.src = '';
    }
    var fileInput = zone.querySelector('input[type="file"]');
    if (fileInput) fileInput.value = '';
    var pct = zone.querySelector('.wb-progress-pct');
    if (pct) pct.textContent = '';
    var content = zone.querySelector('.wb-upload-content');
    if (content) content.style.display = '';
  }
  if (hidden) hidden.value = '';
  var driveInput = document.getElementById(hiddenId + '-drive-id');
  if (driveInput) driveInput.value = '';
  _wbUploading[zoneId] = false;
}

/* ─── Thème autre toggle ─────────────────────────────────────────────────── */

function wbToggleThemeAutre(select) {
  var box = document.getElementById('wb-f-theme-autre');
  if (!box) return;
  if (select.value === 'Autre') {
    box.style.display = '';
    var input = box.querySelector('input');
    if (input) { input.required = true; input.disabled = false; }
  } else {
    box.style.display = 'none';
    var input = box.querySelector('input');
    if (input) { input.required = false; input.value = ''; input.disabled = true; }
  }
}

/* ─── Leçon autre toggle ─────────────────────────────────────────────────── */

function wbToggleLeconAutre(select) {
  var box = document.getElementById('wb-f-lecon-autre');
  if (!box) return;
  if (select.value === 'Autre') {
    box.style.display = '';
    var input = box.querySelector('input');
    if (input) { input.required = true; input.disabled = false; }
  } else {
    box.style.display = 'none';
    var input = box.querySelector('input');
    if (input) { input.required = false; input.value = ''; input.disabled = true; }
  }
}

/* ─── Personnage 2 toggle ────────────────────────────────────────────────── */

function wbTogglePers2(select) {
  var box = document.getElementById('wb-pers2');
  if (!box) return;
  if (select.value === 'Oui') {
    box.classList.add('wb-visible');
  } else {
    box.classList.remove('wb-visible');
    var inputs = box.querySelectorAll('input[type="text"], select');
    inputs.forEach(function(el) { el.value = ''; });
    var urlInput = document.getElementById('wb-photo2-url');
    if (urlInput) urlInput.value = '';
    var zone = document.getElementById('wb-upload2');
    if (zone) {
      zone.classList.remove('wb-has-file', 'wb-uploading');
      var fn = zone.querySelector('.wb-file-name');
      if (fn) fn.textContent = '';
    }
  }
}

/* ─── Photo upload ───────────────────────────────────────────────────────── */

var _wbUploading = {};  // { zoneId: true/false } — bloque le submit si upload en cours

function wbUpload(event, zoneId, hiddenId) {
  var file = event.target.files[0];
  if (!file) return;

  var zone = document.getElementById(zoneId);
  var hidden = document.getElementById(hiddenId);
  if (!zone || !hidden) return;

  var preview = zone.querySelector('.wb-preview');
  if (preview) {
    var previewImg = preview.querySelector('img');
    var previewName = preview.querySelector('.wb-preview-name');
    if (previewImg) previewImg.src = URL.createObjectURL(file);
    if (previewName) previewName.textContent = file.name;
    preview.style.display = 'flex';
  }
  zone.classList.add('wb-uploading', 'wb-has-file');
  var pct = zone.querySelector('.wb-progress-pct');
  if (pct) pct.textContent = 'Téléchargement en cours...';

  setTimeout(function() {
    if (_wbUploading[zoneId]) {
      zone.classList.remove('wb-uploading');
      if (pct) pct.textContent = '✓ Photo ajoutée';
      var field = zone.closest('.wb-field');
      if (field) field.classList.remove('wb-invalid');
    }
  }, 3000);

  _wbUploading[zoneId] = true;
  hidden.value = '';

  function resizeToJpeg(file, maxDim, quality, callback) {
    var img = new Image();
    var url = URL.createObjectURL(file);
    img.onload = function() {
      URL.revokeObjectURL(url);
      var w = img.width, h = img.height;
      if (w > maxDim || h > maxDim) {
        var ratio = Math.min(maxDim / w, maxDim / h);
        w = Math.round(w * ratio);
        h = Math.round(h * ratio);
      }
      var canvas = document.createElement('canvas');
      canvas.width = w; canvas.height = h;
      canvas.getContext('2d').drawImage(img, 0, 0, w, h);
      canvas.toBlob(callback, 'image/jpeg', quality);
    };
    img.onerror = function() { callback(null); };
    img.src = url;
  }

  function doUpload(blob, attemptsLeft) {
    var attempt = 6 - attemptsLeft;  // 1..5
    var delay = attemptsLeft < 5 ? Math.min(2000 * Math.pow(2, attempt - 2), 16000) : 0;

    setTimeout(function() {
      var controller = new AbortController();
      var tid = setTimeout(function() { controller.abort(); }, 20000);
      var formData = new FormData();
      formData.append('file', blob, 'photo_' + Date.now() + '.jpg');
      fetch(UPLOAD_ENDPOINT, { method: 'POST', body: formData, signal: controller.signal })
        .then(function(r) {
          clearTimeout(tid);
          if (!r.ok) throw new Error('Upload ' + r.status);
          return r.json();
        })
        .then(function(data) {
          hidden.value = data.url;
          var driveIdInput = document.getElementById(hiddenId + '-drive-id');
          if (driveIdInput) driveIdInput.value = data.file_id;
          _wbUploading[zoneId] = false;
          zone.classList.remove('wb-uploading');
          if (pct) pct.textContent = '✓';
          var field = zone.closest('.wb-field');
          if (field) field.classList.remove('wb-invalid');
        })
        .catch(function() {
          clearTimeout(tid);
          if (attemptsLeft > 1) {
            doUpload(blob, attemptsLeft - 1);
          } else {
            _wbUploading[zoneId] = false;
            zone.classList.remove('wb-uploading');
            hidden.value = 'UPLOAD_FAILED';
            if (pct) pct.textContent = '⚠ Photo à envoyer par email';
            var field = zone.closest('.wb-field');
            if (field) field.classList.remove('wb-invalid');
          }
        });
    }, delay);
  }

  resizeToJpeg(file, 900, 0.80, function(blob) {
    if (!blob) blob = file;
    doUpload(blob, 5);
  });
}

/* ─── Companion products ─────────────────────────────────────────────────── */

var _wbCart = {};

function wbAddCompanion(key) {
  var variantId = WB_VARIANTS[key];
  if (!variantId) return Promise.resolve();
  if (_wbCart[key]) return Promise.resolve();

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function(res) {
    if (res.ok) _wbCart[key] = true;
  });
}

function wbRemoveCompanion(key) {
  var variantId = WB_VARIANTS[key];
  if (!variantId) return Promise.resolve();
  if (!_wbCart[key]) return Promise.resolve();

  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 })
  }).then(function(res) {
    if (res.ok) _wbCart[key] = false;
  });
}

/* ─── Option handlers ────────────────────────────────────────────────────── */

function wbHandleDuree(select) {
  wbRemoveCompanion('duree_60s');
  wbRemoveCompanion('duree_90s');
  if (select.value === '60 secondes') {
    wbAddCompanion('duree_60s');
  } else if (select.value === '90 secondes') {
    wbAddCompanion('duree_90s');
  }
}

function wbHandleMusique(select) {
  if (select.value === 'Chanson personnalisée') {
    wbAddCompanion('chanson');
  } else {
    wbRemoveCompanion('chanson');
  }
}

function wbHandleLivraison(select) {
  if (select.value === 'Express (24H)') {
    wbAddCompanion('express');
  } else {
    wbRemoveCompanion('express');
  }
}

/* ─── Form validation & submit ───────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('wb-product-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    var valid = true;
    var firstError = null;

    function require(fieldId, valueGetter) {
      var field = document.getElementById(fieldId);
      if (!field) return;
      var val = valueGetter ? valueGetter() : null;
      var empty = val === '' || val === null;
      if (empty) {
        field.classList.add('wb-invalid');
        valid = false;
        if (!firstError) firstError = field;
      } else {
        field.classList.remove('wb-invalid');
      }
    }

    // Étape 1
    require('wb-f-prenom', function() {
      return form.querySelector('[name="properties[Prénom de l\'enfant]"]').value;
    });
    require('wb-f-age', function() {
      return form.querySelector('[name="properties[Âge]"]').value;
    });
    require('wb-f-photo1', function() {
      return document.getElementById('wb-photo1-url').value;
    });
    require('wb-f-yeux1', function() {
      return form.querySelector('[name="properties[couleur-yeux-pers1]"]').value;
    });
    require('wb-f-ajouter', function() {
      return form.querySelector('[name="properties[ajouter-personnage]"]').value;
    });

    // Étape 1 — personnage 2 (only if visible)
    var pers2 = document.getElementById('wb-pers2');
    if (pers2 && pers2.classList.contains('wb-visible')) {
      require('wb-f-pers2nom', function() {
        return form.querySelector('[name="properties[personnage2]"]').value;
      });
      require('wb-f-photo2', function() {
        return document.getElementById('wb-photo2-url').value;
      });
      require('wb-f-yeux2', function() {
        return form.querySelector('[name="properties[couleur-yeux-pers2]"]').value;
      });
    }

    // Étape 2
    require('wb-f-theme', function() {
      return form.querySelector('[name="properties[Thème de l\'histoire]"]').value;
    });
    var themeAutre = document.getElementById('wb-f-theme-autre');
    if (themeAutre && themeAutre.style.display !== 'none') {
      require('wb-f-theme-autre', function() {
        return form.querySelector('[name="properties[Thème - précision]"]').value.trim();
      });
    }
    require('wb-f-ton', function() {
      return form.querySelector('[name="properties[Ton]"]').value;
    });
    require('wb-f-lecon', function() {
      return form.querySelector('[name="properties[Leçon]"]').value;
    });
    var leconAutre = document.getElementById('wb-f-lecon-autre');
    if (leconAutre && leconAutre.style.display !== 'none') {
      require('wb-f-lecon-autre', function() {
        return form.querySelector('[name="properties[Leçon - précision]"]').value.trim();
      });
    }
    require('wb-f-narration', function() {
      return form.querySelector('[name="properties[Narration]"]').value.trim();
    });

    // Étape 3
    require('wb-f-duree', function() {
      return form.querySelector('[name="properties[Durée souhaitée]"]').value;
    });
    require('wb-f-musique', function() {
      return form.querySelector('[name="properties[Musique du film]"]').value;
    });
    require('wb-f-livraison', function() {
      return form.querySelector('[name="properties[Livraison]"]').value;
    });

    if (!valid) {
      e.preventDefault();
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var stepBody = firstError.closest('.wb-step-body');
        if (stepBody && stepBody.classList.contains('wb-hidden')) {
          stepBody.classList.remove('wb-hidden');
          var stepHeader = stepBody.previousElementSibling;
          if (stepHeader) stepHeader.classList.remove('wb-closed');
        }
      }
    }
  });
});
